export const GET_GROUP_INCIDENT_PERFORMANCE = 'GET_GROUP_INCIDENT_PERFORMANCE';
export const GET_GROUP_INCIDENT_PERFORMANCE_START = `${GET_GROUP_INCIDENT_PERFORMANCE}_START`;
export const GET_GROUP_INCIDENT_PERFORMANCE_SUCCESS = `${GET_GROUP_INCIDENT_PERFORMANCE}_SUCCESS`;
export const GET_GROUP_INCIDENT_PERFORMANCE_FAIL = `${GET_GROUP_INCIDENT_PERFORMANCE}_FAIL`;

export const GROUP_INCIDENT_PERFORMANCE_RESET_GROUP_DATA =
  'GROUP_INCIDENT_PERFORMANCE_RESET_GROUP_DATA';

export function getGroupIncidentPerformance(params) {
  // ensure we are not using the array params
  const callParams = params;
  if (callParams?.workflows) {
    callParams.workflows = undefined;
  }
  if (callParams?.services) {
    callParams.services = undefined;
  }
  if (callParams?.supervisor) {
    callParams.supervisor = undefined;
  }
  if (callParams?.groups) {
    callParams.groups = undefined;
  }
  return {
    type: GET_GROUP_INCIDENT_PERFORMANCE,
    meta: {
      xmApi: true,
      method: 'get',
      uri: '/webapi/abe/1/performance/groups/incidents',
      params: {
        limit: 100,
        offset: 0,
        schedule: true,
        ...callParams,
      },
    },
  };
}

export const resetGroupIncidentData = () => {
  return {
    type: GROUP_INCIDENT_PERFORMANCE_RESET_GROUP_DATA,
  };
};
